import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boldMarkedText',
})
export class BoldMarkedTextPipe implements PipeTransform {
  transform(value: string): string {
    const regex = /\*[A-Za-z0-9à-üÀ-Ü\s]+\*/g;
    let str = value;
    const matches = value.match(regex) ?? [];
    for (let match of matches) {
      match = match.replace('*', '<strong>');
      match = match.replace('*', '</strong>');
      str = str.replace(regex, match);
    }
    return str;
  }
}
